export const transformData = (fields, data) => {
  const result = fields.reduce((acc, { label, field }) => {
    if (field in data) {
      // Combine area code and phone number
      if (label === "phone_number" && data.areaCode && data.phoneNumber) {
        acc[label] = data.areaCode + data.phoneNumber;
      } else if (label !== "area_code") {
        // Skip `area_code` itself
        acc[label] = data[field];
      }
    }
    return acc;
  }, {});

  return result;
};
